import React, { useState, useCallback, useEffect, useRef } from "react"
import * as styles from "./RoundBrandTilesWithFilter-tw-styles"
import Typography from "../UI/Typography/Typography"
import PropTypes from "prop-types"
import { get } from "../../helpers/utils"
import BrandTile from "./BrandTile/BrandTile"
import { CLEAR_ALL } from "../../constants/label.constants"
import { gaFilterClick } from "../../constants/gtm.constants"

const style = styles.defaultStyle

const RoundBrandTilesWithFilter = props => {
  const {
    brandsCollection = {},
    categoriesCollection = {},
    filterLabel = "",
  } = props
  const allBrandsData = get(brandsCollection, "items", [])
  const categories = get(categoriesCollection, "items", [])
  const [toggle, setToggle] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState([])
  const [brands, SetBrands] = useState(allBrandsData)
  const ref = useRef(null)

  useEffect(() => {
    if (selectedCategory.length <= 0) {
      return
    }
    filterBrand()
  }, [selectedCategory])

  const handleSelectChange = useCallback(
    category => () => {
      if (category?.label === CLEAR_ALL) {
        setSelectedCategory([])
        SetBrands(allBrandsData)
      } else {
        //select functionality
        if (!selectedCategory.includes(category)) {
          setSelectedCategory(prevState => [...prevState, category])
        } else {
          //de-select functionality
          const arr = selectedCategory.filter(function (item) {
            return item.id !== category.id
          })
          setSelectedCategory(arr)
          if (arr.length <= 0) {
            SetBrands(allBrandsData)
          }
        }
      }
      setToggle(true)
    },
    [selectedCategory, setSelectedCategory]
  )

  function filterBrand() {
    const filteredBrands =
      allBrandsData &&
      allBrandsData?.filter(item => {
        return (
          selectedCategory &&
          selectedCategory?.some(ele => {
            return ele?.id === item?.category?.id
          })
        )
      })
    return SetBrands(filteredBrands)
  }

  function renderBrands() {
    return (
      <div className={style?.brandSection}>
        {brands &&
          brands?.map((item, index) => {
            return <BrandTile item={item} key={index} />
          })}
      </div>
    )
  }

  function renderCategoryList() {
    return categories?.map((item,index) => (
      <li
        className={`${style?.brandFilterRow} ${
          selectedCategory?.includes(item) ? "activated" : ""
        } ${gaFilterClick}`}
        data-action-detail={item?.name}
        key={item?.id}
        onClick={handleSelectChange(item)}
        tabIndex={index}
        onKeyDown={(e)=>{
          if (e.key === "Enter") {
            () => handleSelectChange(item)
          }
        }} 
      >
        <Typography className={style?.filterText} content={item?.name} />
      </li>
    ))
  }

  function setToggleValue() {
    setToggle(!toggle)
  }
  useEffect(() => {
    const handler = event => {
      if (toggle && ref.current && !ref.current.contains(event.target)) {
        setToggle(!toggle)
      }
    }
    document.addEventListener("mousedown", handler)
    document.addEventListener("touchstart", handler)
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler)
      document.removeEventListener("touchstart", handler)
    }
  }, [toggle])

  return (
    <>
      <div className={style?.brandLabelWrapper}>
        <button
          className={`${
            toggle ? "expandBrands brandLabel" : "collpaseBrands brandLabel"
          } ${gaFilterClick}`}
          aria-label={`${toggle ? "Types expand" : "Types collpase"}`}
          aria-expanded={toggle ? "true" : "false"}
          role="button"
          onClick={() => setToggleValue()}
          onKeyDown={(e)=>{
            if (e.key === "Enter") {
              () => setToggleValue()
            }
          }}
          ref={ref}
          data-action-detail={filterLabel}
        >
          <p className={style?.typeFilter}>
            {" "}
            <span data-action-detail={filterLabel}>{filterLabel} </span>
            {selectedCategory?.length > 0 && (
              <span>{"(" + selectedCategory?.length + ")"}</span>
            )}{" "}
          </p>
        </button>
      </div>

      <div className={style?.brandFilterWrapper}>
        <ul
          className={style?.brandFiltersList}
          style={{ maxHeight: toggle ? "100vh" : "0" }}
        >
          {categories && renderCategoryList()}
        </ul>
      </div>
      {renderBrands()}
    </>
  )
}

RoundBrandTilesWithFilter.propTypes = {
  categoriesCollection: PropTypes.object,
  brandsCollection: PropTypes.object,
  filterLabel: PropTypes.string,
}

export default RoundBrandTilesWithFilter